export default class CategoryModel {
    id: number = 0
    defaultDueDate: string = ''
    defaultDueDateString: string = ''
    defaultEscalationDays: number = 0
    assignTo: string = ''
}


// WEBPACK FOOTER //
// ./ClientApp/src/models/CategoryModel.ts